<script setup>
import BadgeBoutique from "@/components/molecules/badge-boutique";
import commercialStickerCodes from "@/utils/commercial-sticker-codes";
import LinkTo from "@/components/atoms/link-to";

const runtimeConfig = useRuntimeConfig();

const props = defineProps({
  article: {
    type: Object,
    required: false,
    default: () => {}
  },
  isFp: {
    type: Boolean,
    required: false,
    default: false
  },
  url: {
    type: String,
    required: false,
    default: null
  }
});

const isBoutiquePartenaire = computed(
  () =>
    props.article.attributes.boutique_partenaire &&
    props.article.attributes.boutique_partenaire.code === "1"
);

const dpClickAndCollectTraiteurUrl = computed(
  () => runtimeConfig.TRAITEUR_PERMANENT_CATEGORY_SLUG
);

const dpClickAndCollectTraiteurNoelUrl = computed(
  () => runtimeConfig.TRAITEUR_DE_FETES_CATEGORY_SLUG
);

const badges = computed(() => {
  const tableauBadges = [];

  if (props.article.attributes.is_deja_achete && !props.isFp) {
    tableauBadges.push({
      variant: "deja-achete",
      label: "Déjà acheté"
    });
  }
  if (props.article.attributes.is_gros_volume) {
    tableauBadges.push({
      variant: "gros-volume",
      isGrosVolume: true
    });
  }
  if (
    props.article.attributes.picto_commercial?.code ===
    commercialStickerCodes.PROMO
  ) {
    tableauBadges.push({
      variant: "promo",
      label: "Promo"
    });
  } else if (props.article.attributes.is_hyper_bon_plan) {
    tableauBadges.push({
      variant: "hypers-bons-plans",
      isHyperBonPlan: true
    });
  }
  if (
    props.article.attributes.picto_commercial?.code ===
    commercialStickerCodes.ITS_IN_SEASON
  ) {
    tableauBadges.push({
      variant: "saison",
      label: "C'est de saison"
    });
  }
  if (props.article.attributes.is_parapharmacie) {
    tableauBadges.push({
      variant: "parapharmacie",
      label: "Parapharmacie",
      link: props.url
    });
  }
  if (
    props.article.attributes.types_panier &&
    props.article.attributes.types_panier.includes(
      "click_and_collect_traiteur_permanent"
    )
  ) {
    tableauBadges.push({
      variant: "plateau-cora",
      label: "Traiteur sur commande",
      link: dpClickAndCollectTraiteurUrl.value
    });
  }
  if (
    props.article.attributes.types_panier &&
    props.article.attributes.types_panier.includes(
      "click_and_collect_traiteur_noel"
    )
  ) {
    tableauBadges.push({
      variant: "traiteur-de-fete",
      label: "Traiteur de Fêtes",
      icon: "traiteur",
      iconColor: "black",
      link: dpClickAndCollectTraiteurNoelUrl.value
    });
  }
  if (props.article.attributes.is_prepare_ici) {
    tableauBadges.push({
      variant: "prepare-ici-pour-vous",
      label: "Préparé ici pour vous",
      icon: "prepare-ici-pour-vous",
      iconColor: "white"
    });
  }
  if (props.article.attributes.boutique_partenaire) {
    tableauBadges.push({
      label: props.article.attributes.boutique_partenaire.nom,
      icon:
        props.article.attributes.boutique_partenaire.code === "1"
          ? "exclu-web"
          : null,
      variant:
        props.article.attributes.boutique_partenaire.code === "1"
          ? "exclu-web"
          : null,
      backgroundColor:
        props.article.attributes.boutique_partenaire.code === "1"
          ? null
          : props.article.attributes.boutique_partenaire.color,
      link: props.url
    });
  }
  if (props.article.attributes.is_local) {
    tableauBadges.push({
      variant: "coralocal",
      label: "Produit Local"
    });
  }
  if (props.article.attributes.is_nouveau) {
    tableauBadges.push({
      variant: "nouveaute",
      label: "Nouveauté"
    });
  }

  return tableauBadges.slice(0, 2);
});
</script>
<template>
  <component
    :is="!!badgeData.link && isFp ? LinkTo : 'div'"
    v-for="(badgeData, index) in badges"
    :key="index"
    no-decoration
    :to="badgeData.link"
    class="u-inline-flex u-flex-align-center"
  >
    <BadgeBoutique
      :variant="badgeData.variant"
      :label="badgeData.label"
      :icon="badgeData.icon"
      :icon-color="badgeData.iconColor"
      :background-color="badgeData.backgroundColor"
      :boutique-survol="!!badgeData.link"
      :is-hyper-bon-plan="badgeData.isHyperBonPlan"
      :is-gros-volume="badgeData.isGrosVolume"
    />
  </component>
</template>
